module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-ons-list-item', {
    attrs: {
      "modifier": "longdivider"
    },
    on: {
      "click": _vm.showDetail
    }
  }, [_c('div', {
    staticClass: "center"
  }, [_c('section', {
    staticClass: "destination-outline"
  }, [_c('h1', {
    staticClass: "destination-outline-title"
  }, [_vm._v(_vm._s(_vm.spot.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.areaName))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.categoryName))]), _vm._v(" "), _c('p', [_vm._v("\n        人気度\n        "), _vm._l((5), function(n) {
    return _c('span', {
      key: n,
      class: ['destination-outline-star', {
        'on': n <= _vm.popularityDegree
      }]
    }, [_vm._v("★")])
  })], 2), _vm._v(" "), _c('p', [_vm._v("\n        混雑度\n        "), (_vm.isOpenSpot) ? _c('span', [_vm._v(_vm._s(_vm.congestionDegree) + "%")]) : _c('span', {
    class: _vm.isAvailable ? 'available' : 'unavailable'
  }, [_vm._v(_vm._s(_vm.avaiableText) + "\n        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('img', {
    staticClass: "image-thumb",
    attrs: {
      "src": _vm.image,
      "width": "130px"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74bc8c40","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/map/partials/destination_outline/spot.vue
// module id = 600
// module chunks = 0